import FieldHint from './FieldHint';

export default function Input({ label, hint, error, className = '', ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label className="label flex items-center">
          {label}
          {hint && <FieldHint text={hint} />}
        </label>
      )}
      <input
        {...props}
        className={`input ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`}
      />
      {error && <p className="mt-1 text-xs text-red-400">{error}</p>}
    </div>
  );
}
